<template>
    <div class="topMenuWrapper">
      <Menubar :model="items" v-if="role != 'Extern'">
        <SearchOrders />
        <VismaStatus />
        <UserMenu/>
      </Menubar>
      <Menubar :model="externalItems" v-else>
        <SearchOrders />
        <UserMenu/>
      </Menubar>
    </div>
</template>

<script>

import Menubar from 'primevue/menubar'
import UserMenu from '@/components/Menus/UserMenu'
import VismaStatus from '@/components/Menus/VismaStatus'
import SearchOrders from '@/components/Orders/searchOrders'

export default {
  name: 'TopMenu',
  data () {
    return {
      role: '',
      items: null,
      disabled: true,
      disabledClass: 'disabled',
      externalItems: []
    }
  },
  components: {
    Menubar,
    UserMenu,
    SearchOrders,
    VismaStatus
  },
  async created () {
    this.role = localStorage.getItem('role')
    if (this.role === 'Admin') {
      this.disabled = false
      this.disabledClass = ''
    }
    let customers = await this.getCustomers()
    customers.unshift({label: 'Visa alla', to: '/OrderListByType/standard'})
    this.externalItems = [
      {
        label: 'Hagéns Åkeri',
        icon: 'pi pi-home',
        to: '#'
      },
      {
        label: 'Planering',
        to: '/planningexternal',
        icon: 'pi pi-calendar'
      },
      {
        label: 'Statistik kund',
        to: '/feralcostats',
        icon: 'pi pi-chart-line'
      },
      {
        label: 'Statistik snitt/mil',
        to: '/distanceStats',
        icon: 'pi pi-chart-line'
      },
      {
        label: 'Statistik leveranser',
        to: '/deliverystats',
        icon: 'pi pi-chart-line'
      }
    ]

    this.items = [
      {
        label: 'Hagéns Åkeri',
        icon: 'pi pi-home',
        to: '/'
      },
      {
        label: 'Ordrar',
        icon: 'pi pi-list',
        items: [
          {
            label: 'Feralco',
            to: '/OrderListByType/feralco'
          },
          {
            label: 'FeralcoIntern',
            to: '/OrderListByType/feralcoIntern'
          },
          {
            label: 'Timkörning',
            items: customers
          },
          {
            label: 'Containers',
            to: '/OrderListByType/container'
          },
          {
            label: 'Arkiv',
            to: '/orderArchive'
          },
          {
            label: 'Admin',
            to: '/orderadmin',
            class: this.disabledClass,
            disabled: this.disabled
          }
        ]
      },
      {
        label: 'Fakturor',
        icon: 'pi pi-money-bill',
        items: [
          {
            label: 'Feralco',
            to: '/invoiceFeralcoList'
          },
          {
            label: 'FeralcoIntern',
            to: '/invoiceFeralcoInternList'
          },
          {
            label: 'Timkörning',
            to: '/invoiceHydroList'
          },
          {
            label: 'Feralco Prislista',
            to: '/feralcoPricesListAdmin'
          },
          {
            label: 'Inställningar',
            to: '/invoiceSettings'
          },
          {
            label: 'Självfakturor',
            to: '/invoiceSubArchive'
          },
          {
            label: 'Arkiv',
            to: '/invoiceArchive'
          }
        ]
      },
      {
        label: 'Planering',
        icon: 'pi pi-calendar',
        to: '/planning'
      },
      {
        label: 'Register',
        icon: 'pi pi-file',
        items: [
          {
            label: 'Kunder',
            to: '/customerList'
          },
          {
            label: 'Underleverantörer',
            to: '/objectDataList/23'
          },
          {
            label: 'Containerpositioner',
            to: '/containerstates'
          },
          {
            label: 'Dokument',
            to: '/documentlist'
          },
          {
            label: 'Leveransställen',
            to: '/customerPlacesList'
          },
          {
            label: 'Lastplatser timkörning',
            to: '/objectDataList/24'
          },
          {
            label: 'Användare',
            to: '/UserList'
          },
          {
            label: 'Fordon',
            items: [
              {
                label: 'Lastbilar',
                items: [
                  {
                    label: 'Dragbil',
                    to: '/objectDataList/1'
                  },
                  {
                    label: 'Kranbil',
                    to: '/objectDataList/2'
                  },
                  {
                    label: 'Lastväxlare',
                    to: '/objectDataList/3'
                  },
                  {
                    label: 'Skåpbil',
                    to: '/objectDataList/4'
                  },
                  {
                    label: 'Tankbil',
                    to: '/objectDataList/5'
                  }
                ]
              },
              {
                label: 'Släp',
                items: [
                  {
                    label: 'Lastväxlarsläp',
                    to: '/objectDataList/6'
                  },
                  {
                    label: 'Skåpsläp',
                    to: '/objectDataList/7'
                  },
                  {
                    label: 'Tanksläp',
                    to: '/objectDataList/8'
                  }
                ]
              },
              {
                label: 'Trailer',
                items: [
                  {
                    label: 'Skåptrailer',
                    to: '/objectDataList/9'
                  }
                ]
              }
            ]
          },
          {
            label: 'Tillbehör',
            items: [
              {
                label: 'Utrustning',
                items: [
                  {
                    label: 'Kranflak',
                    to: '/objectDataList/10'
                  },
                  {
                    label: 'Liftdumper',
                    to: '/objectDataList/11'
                  },
                  {
                    label: 'Truck',
                    to: '/objectDataList/12'
                  }
                ]
              },
              {
                label: 'Container',
                items: [
                  {
                    label: 'Container',
                    to: '/objectDataList/13'
                  },
                  {
                    label: 'Container med lock',
                    to: '/objectDataList/14'
                  },
                  {
                    label: 'Container med öppningsbar sida',
                    to: '/objectDataList/15'
                  },
                  {
                    label: 'Grusflak',
                    to: '/objectDataList/16'
                  }
                ]
              }
            ]
          },
          {
            label: 'Artiklar',
            items: [
              {
                label: 'Standard',
                to: '/objectDataList/17'
              },
              {
                label: 'Feralco',
                to: '/objectDataList/18'
              }
            ]
          },
          {
            label: 'Kalender',
            items: [
              {
                label: 'Händelser',
                to: '/objectDataList/19'
              }
            ]
          },
          {
            label: 'Containerhantering',
            items: [
              {
                label: 'Uppställningsplatser',
                to: '/objectDataList/20'
              },
              {
                label: 'Förbehandlare',
                to: '/objectDataList/21'
              },
              {
                label: 'Fraktioner',
                to: '/objectDataList/22'
              }
            ]
          },
          {
            label: 'Admin',
            to: '/ObjectDataAdmin',
            class: this.disabledClass,
            disabled: this.disabled
          }
        ]
      },
      {
        label: 'Verktyg',
        icon: 'pi pi-eye',
        items: [
          {
            label: 'Daglig tillsyn',
            to: '/dailyCheckup',
            icon: 'pi pi-chart-line'
          },
          {
            label: 'Karta',
            icon: 'pi pi-globe',
            to: '/mapview'
          },
          {
            label: 'Planering arkiv',
            icon: 'pi pi-calendar',
            to: '/planningarchive'
          },
          {
            label: 'Statistik kund',
            to: '/feralcostats',
            icon: 'pi pi-chart-line'
          },
          {
            label: 'Statistik ton',
            to: '/feralcostatstonnage',
            icon: 'pi pi-chart-line'
          },
          {
            label: 'Statistik väntetid',
            to: '/waitstats',
            icon: 'pi pi-chart-line'
          },
          {
            label: 'Statistik snitt/mil',
            to: '/distanceStats',
            icon: 'pi pi-chart-line'
          },
          {
            label: 'Statistik leveranser',
            to: '/deliverystats',
            icon: 'pi pi-chart-line'
          }
        ]
      }
    ]
  },
  methods: {
    async getCustomers () {
      let response = await this.$http.get('/api/customers/by-standard')
      return response.data.customers.map((el) => ({label: el.data.name, to: '/OrderListByType/standard/' + el.id}))
    },
    toggleMenu () {
      var sideMenu = document.querySelector('#sideMenu')
      var toggleBtn = document.querySelector('#sidebarCollapse')
      sideMenu.classList.toggle('active')
      toggleBtn.classList.toggle('open')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menus/TopMenu.vue